import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";



export const searchQuestions = createAsyncThunk(
  "searchQuestions",
  async ({ searchQuery, type }) => { 
    console.log("front search query: " + searchQuery)
    let apiUrl;
    if (type === "basic") {
      apiUrl = `${process.env.REACT_APP_BACKEND_ORIGIN}/api/v1/search/basic?q=${searchQuery}`;
    }else{
      apiUrl = `${process.env.REACT_APP_BACKEND_ORIGIN}/api/v1/search/deep?q=${searchQuery}`;
    }
    try {
      const response = await axios.get(apiUrl);
      return response.data; 
    } catch (error) {
      console.error("Error searching questions:", error);
      throw error;
    }
  }
);




const searchSlice = createSlice({
  name: "searchQuery",
  initialState: {
    isLoading: false,
    data: null,
    error: false,
  },
  extraReducers: (builder) => {
    builder.addCase(searchQuestions.pending, (state) => {
      state.isLoading = true;
      state.error = false;
    });
    builder.addCase(searchQuestions.fulfilled, (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = false;
    });
    builder.addCase(searchQuestions.rejected, (state, action) => {
      console.log("Error:", action.error);
      state.isLoading = false;
      state.error = true;
      state.data = null;
    });
  },
});

export default searchSlice.reducer;
